// @flow
import { List as ImmutableList } from 'immutable';
import * as types from './types';


export function transformVehicleToRequestData(vehicle: types.Category) {
  return {
    id: vehicle.id,
    clientId: vehicle.clientId,
    isDeleted: vehicle.isDeleted,
    modifiedAt: vehicle.modifiedAt,

    name: vehicle.name,
    make: vehicle.make,
    model: vehicle.model,
    year: vehicle.year,
    isDefault: vehicle.isDefault,
    annualOdometer: {
      doPatch: false,  // always overwrite
      vehicleMileages: vehicle.annualOdometer && vehicle.annualOdometer.map((rec) =>
        ({
          id: rec.id,
          year: rec.year,
          odometerStart: rec.odometerStart,
          odometerEnd: rec.odometerEnd,
        })).toJS(),
    },
    currentValue: vehicle.currentValue,
    serviceStartOn: vehicle.serviceStartOn,
    iconType: vehicle.iconType,
  };
}

export function transformResponseToVehicles(response: any) {
  return response.data.resources.map((data) => (
    types.mkVehicle({
      id: data.id,
      clientId: data.clientId,
      isDeleted: data.isDeleted,
      modifiedAt: data.modifiedAt,
      name: data.name,
      make: data.make,
      model: data.model,
      year: data.year,
      isDefault: data.isDefault,
      annualOdometer: data.annualOdometer?.vehicleMileages ?
        new ImmutableList(data.annualOdometer.vehicleMileages.map((rec) => types.mkOdometerYear(rec)))
        : undefined,
      currentValue: data.currentValue,
      serviceStartOn: data.serviceStartOn,
      iconType: data.iconType,
    })
  ));
}

